import script from "./KGlassCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./KGlassCard.vue?vue&type=script&setup=true&lang=ts"

import "./KGlassCard.vue?vue&type=style&index=0&id=ce938b6e&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ce938b6e"]])

export default __exports__